// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA7BCBaMOlrO-84dvncY9ViXy9lt97Hzqs",
  authDomain: "elipse360.firebaseapp.com",
  projectId: "elipse360",
  storageBucket: "elipse360.firebasestorage.app",
  messagingSenderId: "66924260994",
  appId: "1:66924260994:web:41e6d80b1f8899cc1c0e9b"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { app, auth, db };
